<template>
  <transition name="modal">
    <div class="preview">
      <div
        :class="[
          'preview__wrap modal-container-block',
          { preview__wrap_record: records.length }
        ]"
        v-on-clickaway="close"
      >
        <div class="preview__delete" @click="close"></div>
        <div
          :class="[
            'preview__title',
            {
              preview__title_com: comments.length
            }
          ]"
        >
          <span>
            {{ data.name }}
            <a
              v-if="records.length && current_src"
              class="new-tab"
              :href="room_link"
              target="_blank"
              rel="noopener"
            >
              <img
                src="/static/images/elements/icon_new_tab.svg"
                alt="calendar"
              />
            </a>
          </span>
        </div>

        <div class="preview__tools">
          <div class="preview__date">
            <img src="/static/images/elements/calendar_2.svg" alt="calendar" />
            <span>{{ date }}</span>
          </div>

          <div class="preview__date preview__date_clock">
            <img src="/static/images/elements/clock.svg" alt="clock" />
            <span>{{ time }}</span>
          </div>

          <span
            v-if="
              (past_time && !records.length) || (!current_src && records.length)
            "
            class="no-record"
          >
            <img src="static/images/elements/record.svg" />
          </span>

          <vbutton
            v-if="!records.length && !past_time && !comments.length"
            class="btn btn_left"
            :icon="'icon_copy2'"
            :color="'transparent'"
            @click="copy"
          />
          <vbutton
            v-if="!records.length && !past_time && !comments.length"
            class="btn"
            :icon="'icon_room'"
            :color="'transparent'"
            @click="setLocationTo"
          />

          <vbutton
            v-if="current_src"
            class="btn-link"
            label="onlineInterview.room.linkRecord"
            :icon="'icon_copy3'"
            :padding_min="locale === 'ja'"
            :color="'transparent'"
            @click="copy"
          />
          <a
            v-if="current_src"
            :class="[
              'btn-record',
              {
                'btn-record_min': locale === 'ja'
              }
            ]"
            :href="current_src"
            download
          >
            <img src="/static/images/elements/download.svg" alt="download" />
            <span>{{ $tr('responses.presentation.download') }}</span>
          </a>
        </div>

        <div v-if="records.length && current_src" class="preview__record">
          <div class="preview__current-record">
            <player
              ref="player"
              class="preview_video"
              :class="{ preview_video_multiple: records.length > 1 }"
              :src="current_src"
              :muted="config.muted"
              :rate="config.rate"
              :index="step"
              :volume="config.volume"
              @ended="go_next"
            />
          </div>

          <div
            class="preview__controls"
            v-if="records.length > 1 && current_src"
          >
            <vbutton
              class="btn prev"
              :label="prev"
              :color="'grey'"
              :disabled="step === 0"
              :icon="'icon_prev'"
              :type="step === 0 ? 'icon' : ''"
              @click="go_prev"
            />
            <vbutton
              class="btn next"
              :class="{ 'next-icon': step + 1 === records.length }"
              :label="next"
              :color="'grey'"
              :icon_last="true"
              :disabled="step + 1 === records.length"
              :icon="'icon_next'"
              :type="step + 1 === records.length ? 'icon' : ''"
              @click="go_next"
            />
          </div>
        </div>

        <div class="preview__comments" v-if="comments.length">
          <div class="comment" v-for="(item, i) in comments" :key="i">
            <div class="comment__user">{{ `${set_name(item.user.name)}` }}</div>
            <div class="comment__body" v-html="get_item_body(item.body)"></div>
          </div>
        </div>

        <div
          v-else-if="!records_url && !records.length && !past_time"
          class="preview__calendar"
        >
          <add-calendar
            :inline="true"
            :name="data ? data.name : ''"
            :link="room_link"
            :date="data ? data.date_start : ''"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway';
  import Moment from 'moment';
  import addCalendar from './addCalendar.vue';
  import CopyTextToClipboard from '@/components/mixin/CopyTextToClipboard.js';
  import player from '@/routes_new/inner/response/components/player.vue';
  import { transformNL } from '@/_helpers/utils.js';

  export default {
    name: 'preview',

    components: {
      addCalendar,
      player
    },

    mixins: [CopyTextToClipboard, clickaway],

    props: {
      data: {
        type: Object,
        default: {}
      },
      time_format: {
        type: Number,
        default: 24
      },
      locale: {
        type: String,
        default: 'ru'
      }
    },

    data() {
      return {
        step: 0,
        config: {
          muted: false,
          rate: 1,
          volume: 1
        }
      };
    },

    created() {
      this.create_link();
    },

    computed: {
      date() {
        return this.data
          ? Moment(this.data.date_start).format(this.dateFormat)
          : null;
      },

      time() {
        if (!this.data) {
          return null;
        }

        return this.time_format === 24
          ? Moment(this.data.date_start).format('HH:mm')
          : Moment()
              .locale('en')
              .format('h:mm a')
              .toUpperCase();
      },

      past_time() {
        return this.date < Moment().format(this.dateFormat);
      },

      room_link() {
        if (this.records.length) {
          return `${window.location.origin}/online-interview/${this.token_record}`;
        } else {
          return this.data
            ? `${window.location.origin}/online/${this.data.token}`
            : '';
        }
      },

      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      },

      token_record() {
        return this.$store.getters['online_interview/token_record'];
      },

      records() {
        return this.data ? this.data.records : [];
      },

      records_url() {
        return this.records.length ? this.records.some(el => el.url) : null;
      },

      comments() {
        return this.data ? this.data.comments : [];
      },

      current_src() {
        return this.records.length && this.records[this.step].is_ready
          ? this.records[this.step].url
          : null;
      },

      prev() {
        if (this.step === 0) {
          return '';
        } else {
          return 'onlineInterview.room.videoPrev';
        }
      },

      next() {
        if (this.step + 1 === this.records.length) {
          return '';
        } else {
          return 'onlineInterview.room.videoNext';
        }
      }
    },

    methods: {
      close() {
        this.$emit('close');
      },

      get_item_body(body) {
        if (!body) {
          return '';
        }
        return transformNL(body);
      },

      copy() {
        if (this.room_link) {
          this.copyLinkToClipboard(this.room_link);
        }
      },

      create_link() {
        this.$store.dispatch('online_interview/create_link', this.data.id);
      },

      setLocationTo() {
        if (this.room_link !== '') {
          window.open(this.room_link, '_blank');
        }
      },

      go_next() {
        if (this.step + 1 < this.records.length) {
          this.step++;
        }
      },

      go_prev() {
        if (this.step > 0) {
          this.step--;
        }
      },

      set_name(val) {
        if (this.locale === 'ja') {
          return val;
        } else {
          const a = val.split(' ');
          const str = `${a[1]} ${a[0]}`;
          return str;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .preview {
    position: fixed;
    z-index: 9997;
    width: 100%;
    height: calc(100% + 30px);
    top: -20px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;

    ::v-deep .next.vbutton {
      width: 180px;
      padding: 10px 12px;

      &.next-icon {
        width: auto;
      }
    }

    &__wrap {
      width: 640px;
      background: #ffffff;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      border-radius: 4px;
      padding: 40px 22px 55px 48px;
      position: relative;
      box-sizing: border-box;
      max-height: 90%;
      overflow-y: auto;
      transition: all 0.3s ease;

      &_record {
        padding: 38px 50px 39px;

        .preview__tools {
          margin-bottom: 16px;
        }

        .preview__date_clock {
          margin-left: 28px;
        }
      }
    }

    &__title {
      font-weight: 500;
      font-size: 22px;
      line-height: 32px;
      letter-spacing: 0.005em;
      color: #233346;
      margin-bottom: 8px;

      span {
        display: flex;
        align-items: flex-start;
      }

      .new-tab {
        width: 10px;
        height: 10px;
        display: block;
        margin: 4px;
        img {
          display: block;
        }
      }
    }

    &__delete {
      width: 15px;
      height: 15px;
      position: absolute;
      right: 28px;
      top: 28px;
      cursor: pointer;

      &:before,
      &:after {
        position: absolute;
        top: 0;
        right: 50%;
        content: '';
        display: block;
        width: 2px;
        height: 18px;
        background: #7f8b99;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }
    }

    &__tools {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      color: #233346;

      &_record {
        justify-content: flex-start;
      }

      .btn-record {
        display: flex;
        align-items: center;
        color: #233346;
        height: 40px;
        padding: 0 8px;
        &:hover {
          color: #233346;
          background-color: #f4f5f7;
        }

        span {
          display: inline-block;
          margin-left: 9px;
        }

        &_min {
          padding: 0 10px;
        }
      }

      .btn-link {
        margin-left: 7px;
      }

      .btn_left {
        margin-left: auto;
        margin-right: 17px;
      }

      .no-record {
        display: inline-block;
        position: relative;
        margin-left: 69px;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: -4px;
          left: 10px;
          width: 2px;
          height: 28px;
          background: #d2d6e0;
          transform: rotate(45deg);
        }

        img {
          display: block;
        }
      }
    }

    &__date {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &_clock {
        margin-left: 68px;
      }

      span {
        display: inline-block;
        margin-left: 9px;
      }
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 10px;
      margin-bottom: 4px;

      .prev {
        margin-right: 10px;
      }
    }

    &__comments {
      margin-top: 12px;
      max-height: 96px;
      overflow-y: auto;

      .comment {
        margin-bottom: 7px;
        &__user {
          font-weight: normal;
          font-size: 13px;
          line-height: 19px;
          color: #9faab6;
          margin-bottom: 2px;
        }

        &__body {
          line-height: 22px;
          color: #233346;
          padding-right: 10px;
        }
      }
    }
  }
</style>
